import styles from './ChatContextMenu.module.scss'
import ContextMenu, { ContextMenuProps } from '@/components/ContextMenu/Base/ContextMenu';
import MemberId from '@/components/MemberId/MemberId';
import { getChatId } from '@/utils/chats';
import ContextMenuList from '@/components/ContextMenu/ContextMenuList/ContextMenuList';
import { Chat } from '@/store/chats/chats';
import { ComponentProps } from 'react';

interface ChatContextMenuProps {
  visibleContextMenu: boolean
  contextMenuProps: Partial<ContextMenuProps>
  listProps: ComponentProps<typeof ContextMenuList>
  chat?: Chat
}

const ChatContextMenu = (
  {
    visibleContextMenu,
    contextMenuProps,
    listProps,
    chat
  }: ChatContextMenuProps) => {

  return visibleContextMenu
    ? <ContextMenu {...contextMenuProps}>
      <div className={styles.contextListBox}>
        {chat?.type === 'chat' && <MemberId id={getChatId(chat?.$jid || '')}/>}
        <ContextMenuList
          {...listProps}
          className={styles.contextList}
        />
      </div>
    </ContextMenu>
    : null
}

export default ChatContextMenu
